/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 4caf74add78855a03fda95a65d515d83b89ab4489aea7a334120316dd864ca50
 */
import {
  cta_alertButtonBackground,
  cta_alertButtonBackgroundHover,
  cta_linkTextPrimary,
  cta_linkTextPrimaryHover,
} from 'ext-ui/style/colors'
import {
  button_hGapSpacing,
  cornerRadius,
} from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_size_md,
  font_size_xl,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  align-items: center;
  border-radius: ${cornerRadius};
  display: inline-flex;
  font-family: ${font_family_weight_regular};
  font-size: ${font_size_md};
  font-family: ${font_family_weight_medium};
  gap: ${button_hGapSpacing};
  line-height: ${font_size_xl};
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-underline-offset: 2px;
  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease, fill 150ms ease, stroke 150ms ease, text-decoration-color 150ms ease;

  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;
    text-decoration-line: none;
  }

  &.variant-default {
    color: ${cta_linkTextPrimary};

    &:hover {
      color: ${cta_linkTextPrimaryHover};
    }
  }

  &.variant-severe {
    color: ${cta_alertButtonBackground};

    &:hover {
      color: ${cta_alertButtonBackgroundHover};
    }
  }
`
